const Select = ({ className = '', options = [], ...props }) => {

    const selectClass = [
        'select',
        className
    ].join(' ').trim();

    return (
        <div className={selectClass}>
            <select {...props}>
                <option></option>
                {options.map((o) => (
                    <option key={o} value={o}>{o}</option>
                ))}
            </select>
        </div>
    );
};

export { Select };
